import { ICertificateDetails } from "@prostocheck/kep";
import { IKeyOwner } from "@prostocheck/shared";

/**
 * Certificate data is shown to the user as proof that the right key was
 * attached, so it is never translated: a certificate records one name, in one
 * language.
 */
export const toKeyOwner = (certificate: ICertificateDetails): IKeyOwner => ({
  name: certificate.subject,
  taxNumber: certificate.taxNumber ?? "",
  issuer: certificate.issuer,
  validFrom: certificate.validFrom ?? "",
  validTo: certificate.validTo ?? "",
});
